// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XG8y","left":"styles_left__o_yna"};